export const getFirstKey = <T extends object>(arr: [T] | []): keyof T | undefined => {
  if (arr.length === 0) return undefined

  const first = arr[0]
  return Object.keys(first)[0] as keyof T
}
